<template>
  <div class="pa-6" style="width: 100%">
    <ConfirmLeadDialog
      :state="confirmLeadDialog"
      :importedDocuments="importedDocuments"
      :currentNumber="currentNumber"
      :totalNumber="totalNumber"
      @closeDialog="closeConfirmDialog"
      @updateResult="onUpdateResultDocument"
    />
    <CreateLeadForm
      :state="createLeadDialog"
      :products="products"
      :users="users"
      @closeDialog="closeCreate"
      @refresh="updateFinished"
    />
    <LeadProgressDialog :state="progressDialog" @finish="progressFinish" @closeDialog="closeProgress" />
    <ConfirmUpdateDialog :items="this.existedList" @finished="updateFinished" />
    <div class="d-flex justify-space-between align-center mb-6">
      <div class="component-title">Khách hàng tiềm năng</div>
      <div class="d-flex flex-center">
        <v-btn color="primary" width="167px" dark outlined @click="exportDataToExcel">
          <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
        </v-btn>
      </div>
    </div>
    <div class="d-flex justify-end align-center mb-6">
      <v-btn color="primary" class="elevation-0 ml-6" dark @click="exportExampleDataToExcel">
        <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel mẫu
      </v-btn>

      <v-btn color="primary" class="elevation-0 ml-6" width="167px" dark :loading="isSelecting" @click="onUploadClick">
        <v-icon left>mdi-upload</v-icon>Upload Excel
      </v-btn>
      <input
        ref="uploader"
        type="file"
        class="d-none"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        @change="onFileChanged"
      />
      <v-btn color="primary" class="elevation-0 ml-6" dark @click="createLead"> Tạo khách hàng </v-btn>
    </div>
    <v-card outlined class="pa-6 elevation-0 mb-6">
      <LeadFilter :products="products" :users="users" @onFilterChanged="onFilterChanged" />
    </v-card>

    <LeadTable ref="leadTable" :query="filterQuery" />
  </div>
</template>

<script>
const schema = {
  'Số điện thoại': {
    prop: 'phone',
    type: String,
    required: true,
  },
  Tên: {
    prop: 'buyerName',
    type: String,
  },
  Email: {
    prop: 'email',
    type: String,
  },
  'Học sinh': {
    prop: 'data',
    type: String,
    validate: (value) => {
      const students = value.split(' // ')
      const isValid = students.every((student) => {
        const fields = student.split(', ')
        const isEntryValid =
          fields.length === 4 && fields.every((field) => field && (field.trim() !== '' || field === '---'))
        return isEntryValid
      })

      if (!isValid) {
        throw new Error('Sai mẫu thông tin học sinh')
      }
      return isValid
    },
  },
  'Ghi chú': {
    prop: 'note',
    type: String,
  },
}
/* eslint-disable no-unused-vars */
import { mapActions, mapGetters } from 'vuex'
import ExampleExcel from './ExampleExcel.json'
import LeadFilter from './LeadFilter.vue'
import LeadTable from './LeadTable.vue'
import ConfirmLeadDialog from './ConfirmLeadDialog.vue'
import ConfirmUpdateDialog from './ConfirmUpdateDialog.vue'
import CreateLeadForm from '@/components/basic/form/CreateLeadForm.vue'
import readXlsxFile from 'read-excel-file'
import utils from '@/plugins/utils'
import { chunk, concat } from 'lodash'
import { Lead } from '@/plugins/api'
import moment from 'moment'
import formatLead from '@/helpers/translateLead.js'
import * as XLSX from 'xlsx'
import LeadProgressDialog from './LeadProgressDialog.vue'

export default {
  components: {
    LeadFilter,
    LeadTable,
    ConfirmLeadDialog,
    ConfirmUpdateDialog,
    CreateLeadForm,
    LeadProgressDialog,
  },
  data() {
    return {
      dialog: false,
      confirmLeadDialog: false,
      createLeadDialog: false,
      progressDialog: false,
      importedDocuments: [],
      existedList: [],
      leads: [],
      products: [],
      users: [],
      filterQuery: {},
      loading: false,
      loadingDownload: false,
      isSelecting: false,
      currentNumber: 0,
      totalNumber: 0,
      exampleData: ExampleExcel,
      example_json_fields: {
        'Số điện thoại': 'phone',
        Tên: 'buyerName',
        Email: 'email',
        'Học sinh': 'data',
        'Ghi chú': 'note',
      },
      json_fields: {
        'Số điện thoại': 'phone',
        Tên: 'buyerName',
        Email: 'email',
        'Mã học sinh': 'studentCode',
        'Họ tên học sinh': {
          field: 'data',
          callback: (value) => {
            if (value && value.student) return this.getStudentInfo(value.student, 'name')
            return ''
          },
        },
        'Ngày tháng năm sinh': {
          field: 'data',
          callback: (value) => {
            if (value && value.student) return this.getStudentInfo(value.student, 'dob', true)
            return ''
          },
        },
        'Tên trường THCS': {
          field: 'data',
          callback: (value) => {
            if (value && value.student) return this.getStudentInfo(value.student, 'school')
            return ''
          },
        },
        Lớp: {
          field: 'data',
          callback: (value) => {
            if (value && value.student) return this.getStudentInfo(value.student, 'class')
            return ''
          },
        },
        'Điểm Toán': {
          field: 'data',
          callback: (value) => {
            if (value && value.student) return this.getScore(value.student, 'mathScore')
            return ''
          },
        },
        'Điểm Tiếng Anh': {
          field: 'data',
          callback: (value) => {
            if (value && value.student) return this.getScore(value.student, 'englishScore')
            return ''
          },
        },
        'Ngày tạo': {
          field: 'createdAt',
          callback: (value) => {
            if (value) return moment(value).format('DD/MM/YYYY')
            return ''
          },
        },
        'Người tạo': 'createdByName',
        'Nguồn marketing': 'importedOrigin',
        'Hệ đào tạo': 'product',
        'Nguyện vọng 1': 'expectSchool',
        'Ghi chú': 'note',
        'G.Đ chăm sóc': {
          field: 'status',
          callback: (value) => {
            return formatLead(value)
          },
        },
        'Người phụ trách': 'inCharge.name',
      },
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'isAuthenticated']),
  },
  mounted() {
    this.getProducts()
    this.getUsers()
  },
  methods: {
    ...mapActions('lead', ['createLead', 'fetchLeads', 'fetchLeadProgress', 'updateLeadProgress']),
    ...mapActions('product', ['fetchProducts']),
    ...mapActions('user', ['fetchUsers']),
    closeConfirmDialog() {
      this.isSelecting
      this.confirmLeadDialog = false
      this.$refs.uploader.value = null
    },
    async onUploadClick() {
      this.$loading.active = true
      const progress = await this.fetchLeadProgress()
      if (progress.status === 'available') {
        this.isSelecting = true
        window.addEventListener(
          'focus',
          () => {
            this.isSelecting = false
          },
          { once: true }
        )
        this.$refs.uploader.click()
      } else if (progress.status === 'finish') {
        this.$alert.success('Thao tác upload trước đã thành công! Xin Vui lòng upload tiếp.')
        const updateData = {
          status: 'available',
        }
        await this.updateLeadProgress({ id: progress.id, ...updateData })
        if (progress.data && progress.data.existedList) {
          this.existedList = progress.data.existedList
        } else {
          this.isSelecting = true
          window.addEventListener(
            'focus',
            () => {
              this.isSelecting = false
            },
            { once: true }
          )
          this.$refs.uploader.click()
        }
      } else if (progress.status === 'creating') {
        this.progressDialog = true
      }
      this.$loading.active = false
    },
    progressFinish(data) {
      if (data) {
        this.existedList = data.existedList
      }
    },
    closeProgress() {
      this.progressDialog = false
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema,
        })
      } catch (error) {
        console.error(error)
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      this.$alert.success('Đã đọc File thành công!')
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const data = readFileResult.rows
        this.importedDocuments = data
        this.confirmLeadDialog = true
      }
      this.$loading.active = false
    },
    async onUpdateResultDocument(data) {
      this.$refs.uploader.value = null
      this.totalNumber = data.length
      this.currentNumber = 0
      let existLeadList = []
      this.existLeadList = []
      const leads = []
      for (const lead of data) {
        lead.inCharge = []
        lead.inCharge.push(this.user.id)
        lead.createdBy = this.user.id
        lead.createdByName = this.user.name
        if (lead.data) {
          const studentData = lead.data
          const students = studentData.split('//')
          let student = []
          const data = {
            student,
          }
          for (const studentValue of students) {
            const values = studentValue.split(',')
            const name = values[0].trim()
            const dob = values[1].trim()
            const school = values[2].trim()
            const currClass = values[3].trim()

            if (name) {
              const cleanedName = utils.removeUnicode(name).toLowerCase()
              lead.studentNameSearchField = lead.studentNameSearchField
                ? lead.studentNameSearchField + ' // ' + cleanedName
                : cleanedName
            }
            if (school) {
              const cleanedSchool = utils.removeUnicode(school).toLowerCase()
              lead.studentSchoolSearchField = lead.studentSchoolSearchField
                ? lead.studentSchoolSearchField + ' // ' + cleanedSchool
                : cleanedSchool
            }
            if (currClass) {
              const cleanedGrade = utils.removeUnicode(currClass).toLowerCase()
              lead.studentClassSearchField = lead.studentClassSearchField
                ? lead.studentClassSearchField + ' // ' + cleanedGrade
                : cleanedGrade
            }

            const dataItem = {
              name: name === '---' ? '' : name,
              dob: dob === '---' ? '' : dob,
              class: currClass === '---' ? '' : currClass,
              school: school === '---' ? '' : school,
            }
            student.push(dataItem)
          }

          if (student.length > 0) {
            lead.data = data
          }
        }
        leads.push(lead)
      }
      if (leads.length > 0) {
        const leadRequest = await Lead.createManyLead(leads)
        if (!leadRequest) {
          this.$alert.error('Lỗi tải file lên. Xin vui lòng thử lại')
          this.confirmLeadDialog = false
          this.$refs.leadTable.refresh()
        } else {
          this.progressDialog = true
        }
      }

      this.existedList = existLeadList
      existLeadList = []
      this.$alert.success('Đã tạo khách hàng thành công')
      this.confirmLeadDialog = false
      // this.$refs.leadTable.refresh()
    },
    onFilterChanged(query) {
      this.filterQuery = query
    },
    async getLeadsExcel() {
      this.$loading.active = true
      const leads = await this.fetchLeads({ isArchived: 'false', _limit: -1 })
      this.leads = leads
      this.$loading.active = false
    },
    async getProducts() {
      const products = await this.fetchProducts()
      this.products = products
    },
    async getUsers() {
      const users = await this.fetchUsers({ role_in: ['5d9227b2c887bb6b3283f776', '6569abe679c575d1488858f2'] })
      this.users = users
    },
    formatDataForExport(data) {
      return data.map((item) => {
        let formattedItem = {}
        for (let key in this.json_fields) {
          const fieldInfo = this.json_fields[key]
          let value = item

          const fieldPath = typeof fieldInfo === 'string' ? fieldInfo : fieldInfo.field
          const pathParts = fieldPath.split('.')
          pathParts.forEach((part) => {
            if (value) {
              value = value[part]
            }
          })

          if (typeof fieldInfo === 'object' && fieldInfo.callback) {
            value = fieldInfo.callback(value)
          }

          formattedItem[key] = value || ''

          if (key === 'Số điện thoại' && value) {
            formattedItem[key] = { v: value, t: 's' }
          }
        }
        return formattedItem
      })
    },

    async exportDataToExcel() {
      await this.getLeadsExcel()
      const formattedData = this.formatDataForExport(this.leads)
      const worksheet = XLSX.utils.json_to_sheet(formattedData)

      this.setColumnWidths(worksheet, formattedData)

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads')

      XLSX.writeFile(workbook, 'danh-sach-khach-hang.xlsx')
      this.$loading.active = false
    },
    setColumnWidths(worksheet, data) {
      let maxWidths = []
      const columnNames = data.length > 0 ? Object.keys(data[0]) : []

      columnNames.forEach((name, index) => {
        maxWidths[index] = name.length
      })

      data.forEach((row) => {
        columnNames.forEach((name, index) => {
          const value = (row[name] || '').toString().trim()
          maxWidths[index] = Math.max(maxWidths[index], value.length)
        })
      })
      worksheet['!cols'] = maxWidths.map((width) => ({ width }))
    },
    createLead() {
      this.createLeadDialog = true
    },
    closeCreate() {
      this.createLeadDialog = false
    },

    exportExampleDataToExcel() {
      const formattedData = this.exampleData.map((item) => {
        let formattedItem = {}
        for (let key in this.example_json_fields) {
          let value = item[this.example_json_fields[key]]

          if (key === 'Số điện thoại' && value) {
            formattedItem[key] = { v: value, t: 's' }
          } else {
            formattedItem[key] = value || ''
          }
        }
        return formattedItem
      })
      const worksheet = XLSX.utils.json_to_sheet(formattedData)
      this.setColumnWidths(worksheet, formattedData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Example Leads')

      XLSX.writeFile(workbook, 'example-danh-sach-khach-hang.xlsx')
    },
    convert(studentsArray) {
      if (!Array.isArray(studentsArray) || studentsArray.length === 0) {
        return ''
      }

      return studentsArray
        .map((student) => {
          const name = student.name || '---'
          const dob = student.dob || '---'
          const currClass = student.class || '---'
          const school = student.school || '---'

          return [name, dob, currClass, school].join(', ')
        })
        .join(' // ')
    },
    getStudentInfo(studentsArray, field, formatDate = false) {
      if (!Array.isArray(studentsArray) || studentsArray.length === 0) {
        return ''
      }

      return studentsArray
        .map((student) => {
          if (student[field]) {
            if (formatDate && field === 'dob') {
              // Chuyển đổi định dạng ngày tháng sang DD/MM/YYYY nếu có thể
              const dateValue = student[field]
              if (dateValue && moment(dateValue, 'YYYY-MM-DD', true).isValid()) {
                return moment(dateValue).format('DD/MM/YYYY')
              }
              return dateValue
            }
            return student[field]
          }
          return '---'
        })
        .join(' // ')
    },
    getScore(studentsArray, type) {
      return studentsArray
        .map((student) => {
          if (student[type]) return `${student[type]}`
          return '---'
        })
        .join(' // ')
    },
    updateFinished() {
      this.$refs.leadTable.refresh()
    },
  },
}
</script>

<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
